import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

// CSS Import
import "./index.css";

// SVG Import

// EMAIL Import
import emailjs from "@emailjs/browser";

// REDUX Import

// COMPONENTS Import
import Footer from "../../../../components/LandingPage/Footer";
import ICONS from "../../../../assets/Icons";
import CommonToast from "../../../../components/_utils/CommonToast";

const BookDemo = () => {
  // useRef
  const emailRef = useRef();
  const contactRef = useRef();
  const fullNameRef = useRef();
  const companyNameRef = useRef();
  const requirementRef = useRef();

  // useState
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [fullName, setFullName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [requirement, setRequirement] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(null);
  const [isValidContact, setIsValidContact] = useState(null);

  const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]+$/;

  // useEffect
  useEffect(() => {
    emailjs.init("BYAIWqAyYJKmVXOHA");
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email address.";
    }
    if (!/^\d{10}$/.test(contact)) {
      newErrors.contact =
        "Please enter a valid 10-digit contact number with +91.";
    }
    return Object.keys(newErrors).length === 0;
  };

  const handleEmailChange = (e) => {
    let emailValue = e.target.value.replace(/\s/g, "").toLowerCase();
    setEmail(emailValue);
    if (emailValue === "") {
      setIsValidEmail(null);
      toast.dismiss();
    } else if (emailRegex.test(emailValue)) {
      setIsValidEmail(true);
      toast.dismiss();
    } else {
      setIsValidEmail(false);
    }
  };

  const handleInputChange = (e) => {
    let contactNumber = e.target.value;
    if (/^\d{0,10}$/.test(contactNumber)) {
      setContact(contactNumber);
    }
    if (
      contactNumber.length > 0 &&
      contactNumber.length === 10 &&
      /^\d{0,10}$/.test(contactNumber)
    ) {
      setIsValidContact(true);
      toast.dismiss();
    } else {
      setIsValidContact(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const serviceId = "service_bt8vaud";
    const templateId = "template_qkqs9w6";
    try {
      await emailjs.send(serviceId, templateId, {
        fullName: fullNameRef.current.value,
        email: emailRef.current.value,
        contact: contactRef.current.value,
        companyName: companyNameRef.current.value,
        requirement: requirementRef.current.value,
      });
      CommonToast({
        text: "Your request has been submitted successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      setFullName("");
      setEmail("");
      setContact("");
      setCompanyName("");
      setRequirement("");
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  const handleInvalidIconClick = (type) => {
    let message;
    switch (type) {
      case "email":
        if (!isValidEmail) {
          message = "The email you entered is invalid.";
        }
        break;
      case "contact":
        if (!isValidContact) {
          message = "The contact number you entered is invalid.";
        }
        break;
      default:
        console.error("Invalid type passed :", type);
        return;
    }
    if (message) {
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === " " || e.code === "Space") {
      e.preventDefault();
    }
  };
  const buttonDisabled =
    !fullName.trim() ||
    !email.trim() ||
    !contact.trim() ||
    !companyName.trim() ||
    !requirement.trim() ||
    !emailRegex.test(email.trim()) ||
    !/^\d{10}$/.test(contact.trim());

  return (
    <>
      <div>
        <div>
          <div
            style={{
              minHeight: "100vh",
              overflowY: "scroll",
              msOverflowStyle: "none",
              WebkitOverflowScrolling: "touch",
            }}
            className="bg-[#031f4f] lg:flex lg:flex-col [scrollbar-width:none]"
          >
            <div className="px-[30px] lg:px-padding-base py-[30px] lg:py-padding-base  lg:pb-padding-lg mt-[60px] lg:mt-margin-lg flex flex-col gap-2.5 text-text-primary bg-[#1D3A6D] lg:flex lg:flex-1 lg:justify-center">
              <div className="h-full max-w-[1440px] w-full flex justify-center mx-auto">
                <div className="w-full md:w-[80%] lg:w-[50%] flex flex-col justify-center px-4 lg:px-padding-base  ">
                  <h3 className="lg:text-center lg:pt-[60px] lg:leading-[unset]  text-base lg:text-font-xl lg:pb-padding-md text-font-md   font-semibold text-text-primary">
                    Request a <span className="text-pending">demo</span>
                  </h3>
                  <div className="rounded-2xl md:p-6 lg:p-padding-base lg:bg-custom-lightBlue ">
                    <form
                      className="mt-margin-md lg:mt-margin-xs lg:p-padding-md"
                      onSubmit={handleSubmit}
                    >
                      <p className="text-[#DADADA] text-sm font-semibold ">
                        Request a personalised demo to explore how it can
                        streamline your operations!
                      </p>
                      <div className="grid grid-cols-1 gap-x-6 gap-y-3  md:gap-y-8 md:grid-cols-2 mt-4">
                        <div className="w-full">
                          <label
                            htmlFor="fullName"
                            className="  lg:block lg:text-font-xxs text-xs font-medium leading-6 text-text-primary lg:text-[#DADADA]"
                          >
                            Full name
                          </label>
                          <input
                            style={{
                              caretColor: "var(--text-primary)",
                            }}
                            ref={fullNameRef}
                            id="fullName"
                            name="fullName"
                            type="text"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                            placeholder="Enter your name"
                            className=" block w-full rounded-md border border-[#DADADA] bg-transparent py-1.5 px-2.5 text-xs placeholder:text-xs text-[#DADADA]"
                          />
                        </div>

                        <div className="w-full">
                          <label
                            htmlFor="email"
                            className={` lg:block lg:text-font-xxs text-xs  font-medium leading-6 text-text-primary lg:text-[#DADADA]`}
                          >
                            Email ID
                          </label>
                          <div
                            className={`flex justify-between rounded-md border py-1.5 px-2.5 border-[#DADADA]`}
                          >
                            <input
                              style={{
                                caretColor: "var(--text-primary)",
                              }}
                              ref={emailRef}
                              id="email"
                              name="email"
                              type="text"
                              value={email}
                              onKeyDown={handleKeyDown}
                              onChange={handleEmailChange}
                              placeholder="Enter your email ID"
                              className=" block w-full bg-transparent text-xs placeholder:text-xs text-[#DADADA]"
                            />
                            {isValidEmail !== null && !isValidEmail && (
                              <img
                                src={ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE}
                                alt="Invalid"
                                className="w-[16px] h-[16px] ml-[10px] cursor-pointer"
                                onClick={() => handleInvalidIconClick("email")}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 gap-x-6 gap-y-4 md:gap-y-8 md:grid-cols-2 mt-2">
                        <div className="w-full">
                          <label
                            htmlFor="contact"
                            className={` lg:block lg:text-font-xxs text-xs  font-medium leading-6 text-text-primary  lg:text-[#DADADA]`}
                          >
                            Contact number
                          </label>
                          <div
                            className={`flex justify-between rounded-md border py-1.5 px-2.5 border-[#DADADA]`}
                          >
                            <p className="text-xs placeholder:text-base text-[#DADADA] mr-[2px]">
                              +91{" "}
                            </p>
                            <input
                              style={{
                                caretColor: "var(--text-primary)",
                              }}
                              ref={contactRef}
                              id="contact"
                              name="contact"
                              type="text"
                              max={10}
                              value={contact}
                              onChange={handleInputChange}
                              placeholder="Enter your contact number"
                              className=" block w-full bg-transparent text-xs placeholder:text-xs text-[#DADADA]"
                            />
                            {contact.length < 10 && contact.length > 0 && (
                              <img
                                src={ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE}
                                alt="Invalid"
                                className="w-[16px] h-[16px] cursor-pointer"
                                onClick={() =>
                                  handleInvalidIconClick("contact")
                                }
                              />
                            )}
                          </div>
                        </div>

                        <div className="w-full">
                          <label
                            htmlFor="companyName"
                            className="lg:block lg:text-font-xxs  text-xs font-medium leading-6 text-text-primary  lg:text-[#DADADA]"
                          >
                            Company name
                          </label>
                          <input
                            style={{
                              caretColor: "var(--text-primary)",
                            }}
                            ref={companyNameRef}
                            id="companyName"
                            name="companyName"
                            type="text"
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                            placeholder="Enter your company's name"
                            className=" block w-full rounded-md border border-[#DADADA] bg-transparent py-1.5 px-2.5 text-xs placeholder:text-xs text-[#DADADA]"
                          />
                        </div>
                      </div>

                      <div className="w-full mt-2 ">
                        <label
                          htmlFor="requirement"
                          className=" lg:block lg:text-font-xxs text-xs font-medium leading-6 text-text-primary  lg:text-[#DADADA]"
                        >
                          Requirement
                        </label>
                        <textarea
                          style={{
                            caretColor: "var(--text-primary)",
                          }}
                          ref={requirementRef}
                          rows={8}
                          id="requirement"
                          name="requirement"
                          value={requirement}
                          onChange={(e) => setRequirement(e.target.value)}
                          placeholder="Describe your requirement"
                          className=" block w-full rounded-md border border-[#DADADA] bg-transparent py-1.5 px-2.5 text-xs placeholder:text-xs text-[#DADADA]"
                        />
                      </div>

                      <div className="mt-6 flex items-center justify-center md:justify-end gap-x-6">
                        <button
                          type="submit"
                          disabled={buttonDisabled}
                          className={`rounded-[50px] px-7 py-2 text-sm font-semibold ${
                            buttonDisabled
                              ? "bg-[#707070] text-[#DADADA] cursor-default"
                              : "bg-text-primary text-[#1D3A6D]  hover:bg-hover-bg-white-dark cursor-pointer"
                          }`}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default BookDemo;
